import { UserAtom } from "_states";
import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

const PrivateRoute = ({ children }: any) => {
  const user = useRecoilValue(UserAtom);
  return user ? children : <Navigate to="/auth/login" />;
};

export { PrivateRoute };
